import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import { WhatsAppFab } from "./components/WhatsAppFab";

import HomePage from "./pages/Home";
import ChiSiamoPage from "./pages/ChiSiamo";
import ServiziPage from "./pages/Servizi";
import ConsulenzaPage from "./pages/Consulenza";
import ContattiPage from "./pages/Contatti";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App bg-slate-950 min-h-screen">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/chi-siamo" element={<ChiSiamoPage />} />
            <Route path="/servizi" element={<ServiziPage />} />
            <Route path="/consulenza" element={<ConsulenzaPage />} />
            <Route path="/contatti" element={<ContattiPage />} />
            <Route path="*" element={<HomePage />} />
          </Routes>
        </main>
        <Footer />
        <WhatsAppFab />
        <Toaster
          position="top-center"
          theme="dark"
          toastOptions={{
            style: {
              background: "#0f172a",
              color: "#fff",
              border: "1px solid rgba(16, 185, 129, 0.3)",
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
